import axios from 'axios';

export const setupAxiosInterceptors = () => {
  // Response interceptor for global error handling
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      console.error('[Axios Interceptor] Error:', error);

      if (error.response?.status === 401) {
        // Session expired
        console.warn('Session expired, redirecting to login...');
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login?sessionExpired=true';
        return Promise.reject(error);
      }

      if (!error.response) {
        // Network error
        console.error('Network error - server might be down');
      }

      return Promise.reject(error);
    }
  );
};
